import {
  FormArray,
  FormInput,
  ISelectType,
  useFormContext,
} from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { useFieldArray } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import HealthProgramLang from "./HealthProgramLang";
import { memo, useState } from "react";
import { THealthProgramForm } from "./HealthProgramSchema";

const translationPath = "page.4uHcp.hcp.workGroups.";

interface IHealthProgramLanguagesProps {
  allLanguages: ISelectType[];
}

const HealthProgramLanguages = ({
  allLanguages,
}: IHealthProgramLanguagesProps) => {
  const { t } = useTranslation();

  const { control, formState } = useFormContext<THealthProgramForm>();

  const [defaultLang, setDefaultLang] = useState<ISelectType>();

  const workGroupLanguagesArray = useFieldArray<
    THealthProgramForm,
    "healthProgramLanguages",
    "key"
  >({
    control,
    name: "healthProgramLanguages",
    keyName: "key",
  });

  return (
    <>
      {formState.errors?.healthProgramLanguages &&
        workGroupLanguagesArray.fields.length === 0 && (
          <Typography variant="body2" color={"error"}>
            {formState.errors?.healthProgramLanguages?.root?.message
              ? t(`${formState.errors?.healthProgramLanguages?.root?.message}`)
              : t(`${formState.errors?.healthProgramLanguages?.message}`)}
          </Typography>
        )}
      <FormArray
        title={""}
        name="healthProgramLanguages"
        addButtonLabel={t(translationPath + "add_language") || "Add Language"}
        formArray={workGroupLanguagesArray}
        showAddButton={
          workGroupLanguagesArray.fields.length !== 0 && !defaultLang
            ? false
            : true
        }
        appendValue={{
          name: "",
          description: "",
          language: defaultLang ? defaultLang : allLanguages[0],
        }}
        fieldsObject={(index) => {
          const name = `healthProgramLanguages.${index}.name`;
          const description = `healthProgramLanguages.${index}.description`;
          const language = `healthProgramLanguages.${index}.language`;

          return (
            <>
              <Grid item xs={12} sm={6}>
                <FormInput
                  name={name}
                  size="small"
                  label={t(translationPath + "name")}
                  fullWidth
                />
              </Grid>

              <HealthProgramLang
                index={index}
                name={language}
                allLanguages={allLanguages}
                loadDefaultLang={setDefaultLang}
              />

              <Grid item sm={12}>
                <FormInput
                  name={description}
                  size="small"
                  label={t(translationPath + "description")}
                  fullWidth
                  multiline
                  minRows={4}
                />
              </Grid>
            </>
          );
        }}
      />
    </>
  );
};

export default memo(HealthProgramLanguages);
